<div class="reage-dialog" >
<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true"
  [style]="{'max-width':'500px','width':'50%'}" [resizable]="false">

  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between mx-2 mt-1">
      <h6 class="reage-title">{{headerText}}</h6>
      <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text">
        <img src="assets/qwyn/icons/close.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="reage-body mx-2">
    <form >
      <div class="d-flex w-100 align-items-center justify-content-center">
          <div class="margin-box" [innerHTML]="getFormattedText(labelText)"></div>
      </div>
    </form>
  </div>
  <p-footer *ngIf="isMessage">
    <div class="d-flex flex-row flex-wrap  btn-wrapper px-3  justify-content-center">
      <button type="reset" #cancelBtn  [attr.autofocus]="null" class="btn clear-btn" (click)="hideModal()">Cancel</button>
      <button class="btn search-btn " [attr.autofocus]="null" (click)="updateReAge()">Confirm</button>
    </div>
  </p-footer>
</p-dialog>
</div>